import { render, staticRenderFns } from "./GeneralInfoSummary.vue?vue&type=template&id=5cabcdfe&scoped=true&"
import script from "./GeneralInfoSummary.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabcdfe",
  null
  
)

export default component.exports